




































import { ValidationProvider } from "vee-validate";
import { Component, Vue, Ref, Emit, Prop, Watch } from "vue-property-decorator";

@Component({
    components: {
        ValidationProvider
    }
})
export default class FormFile extends Vue {
    @Prop() value!: any;

    @Prop({ default: false }) required!: boolean;

    @Prop({ default: "upload" }) name!: string;

    @Prop({ default: "upload" }) label!: string;

    @Prop({ default: "all" }) accept!: "all" | "images" | "files";

    @Prop({ default: "Upload hier je bestanden" }) placeholder?: string;

    @Prop() rules?: string | object;

    @Ref() readonly fileEl!: HTMLElement;

    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    isFocussed = false;

    validAtleastOnce = false;

    localFiles = [];

    localFileObjects = [];

    get acceptTypes() {
        if (this.accept === "all") {
            return ".jpg,.jpeg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        }

        if (this.accept === "images") {
            return ".jpg,.jpeg,.png";
        }

        if (this.accept === "files") {
            return ".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        }
    }

    get acceptTypesLabels() {
        if (this.accept === "all") {
            return "jpg, jpeg, png, pdf, doc, docx tot 5MB";
        }

        if (this.accept === "images") {
            return "jpg, jpeg, png tot 5MB";
        }

        if (this.accept === "files") {
            return "pdf, doc, docx tot 5MB";
        }
    }

    private get formValdiated(): boolean {
        return this.provider.$_veeObserver?.flags?.validated;
    }

    handleFileUpload(e: any) {
        // @ts-ignore
        this.localFiles = this.fileEl.files;

        this.onFileChange();

        // @ts-ignore
        this.provider.validate(e);

        this.emitFile();
    }

    mounted() {
        this.onFileChange();
    }

    onFileChange() {
        // @ts-ignore
        const files: any = this.localFiles ?? [];

        Object.values(files).forEach((file: any) => {
            if (!file) {
                return false;
            }
            const that = this;
            // @ts-ignore
            if (file.type.match("image.*")) {
                const reader = new FileReader();
                reader.onload = function(e) {
                    // @ts-ignore
                    that.localFileObjects.push({ preview: e.target.result, name: file.name });
                };
                // @ts-ignore
                reader.readAsDataURL(file);
            } else {
                // @ts-ignore
                that.localFileObjects.push({ preview: null, name: file.name });
            }
        });
    }

    private removeFile(fileObject: any, index: number) {
        // @ts-ignore
        const fileListArr = [...this.fileEl.files].filter((f: File) => f.name !== fileObject.name);

        const dataTransfer = new DataTransfer();

        fileListArr.forEach((file: any) => {
            dataTransfer.items.add(file);
        });

        // @ts-ignore
        this.fileEl.files = dataTransfer.files;

        this.localFileObjects = [];

        this.handleFileUpload(fileObject);
    }

    private get validateAs(): string {
        if (this.label) {
            return this.label;
        }

        if (this.placeholder) {
            return this.placeholder;
        }

        if (this.name) {
            return this.name;
        }

        return `select field`;
    }

    private eagerIfDirty(_a: { flags: any; errors: any }) {
        var errors = _a.errors;
        var flags = _a.flags;
        if (errors.length) {
            return {
                on: ["input", "change"]
            };
        }

        if (flags.valid && !this.validAtleastOnce) {
            this.validAtleastOnce = true;
        }

        if (flags.dirty) {
            return {
                on: ["change", "blur", "input"]
            };
        }

        return {
            on: ["change"]
        };
    }

    @Emit("blur")
    private handleBlur(e: Event): Event {
        if (this.provider && this.provider.flags.dirty) {
            this.validAtleastOnce = true;
        }
        this.isFocussed = false;
        return e;
    }

    @Emit("focus")
    private handleFocus(e: Event): Event {
        this.isFocussed = true;
        return e;
    }

    @Emit("input")
    emitFile() {
        return this.localFiles;
    }

    @Watch("value", { immediate: true })
    handleValueChange(newValue: any) {
        this.localFiles = newValue;

        if (!this.localFiles || !this.localFiles.length) {
            this.localFileObjects = [];
        }
    }
}
